export const getGenderText = gender => {
  const map = new Map([
    [0, '未知'],
    [1, '男'],
    [2, '女'],
  ])
  return map.get(gender) || '未知'
}
